import React, { lazy, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";

// Landing page stays eager (paints right after the boot splash); the rest are
// code-split and loaded on demand behind the Suspense fallback in Layout.
const About = lazy(() => import("./pages/About"));
const ServicesOverview = lazy(() => import("./pages/ServicesOverview"));
const Transportation = lazy(() => import("./pages/Transportation"));
const Warehousing = lazy(() => import("./pages/Warehousing"));
const Machinery = lazy(() => import("./pages/Machinery"));
const Contact = lazy(() => import("./pages/Contact"));
const Faq = lazy(() => import("./pages/Faq"));
const Careers = lazy(() => import("./pages/Careers"));
const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<ServicesOverview />} />
          <Route path="/transportation" element={<Transportation />} />
          <Route path="/warehouse" element={<Warehousing />} />
          <Route path="/machinery" element={<Machinery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
